module.exports = __webpack_public_path__ + "static/img/case_detail_17_3_h5.d571084.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_17_3_h5.png
// module id = 67i7
// module chunks = 34